
export default {
    // 设置当前面包屑初默认
    setActive (state, path) {
      state.defaultActive = path
    },
    // 是否显示推荐套餐
    setShowPackage(state,val){
        state.isShowPackage = val
    },
    // 设置导航面包屑
    setBreadcrumbList (state, arr) {
      state.breadcrumbList = arr;
    },
    setToken (state, val) {
      state.token = val
    },
    setUserName (state, val) {
      state.userName = val
    },
    setTheme (state, val) {
      localStorage.setItem("color", val)
      state.themeColor = val
    }
  }



// WEBPACK FOOTER //
// ./src/store/mutations/mutations.js